module.exports = __webpack_public_path__ + "static/img/zljt.e3cf90b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/zljt.png
// module id = 5MXh
// module chunks = 44